import { proxyApi, type SessionAuthTokenPost } from '@capsicum/common';

export const getSessionAuthenticationToken = async (): Promise<{ code: string }> => {
	const api = await proxyApi;

	return (await api.postSessionAuthToken()).data as Required<SessionAuthTokenPost>;
};
